import { default as IdentityAvatarIcon } from './IdentityAvatarIcon';
export default IdentityAvatarIcon;
